import { SkogsvardAtgardsTyp, VirkeskopAtgardsgrupper } from "~app/common/models/constants";
import { IVKAtgardKedjaKopplingMasshanteringsResponseDTO } from "../../models/Atgardskedjor/atgardskedjor-models";

export class AtgardKedjaValidator {
    validateMessages: string[] = [];

    validate(kedjaKopplingar: IVKAtgardKedjaKopplingMasshanteringsResponseDTO[]) {
        this.validateMessages = [];
        this.pushMetod(this.validateSiktrojning(kedjaKopplingar));
        this.pushMetod(this.validateGrot(kedjaKopplingar));
    }

    private pushMetod(message: string) {
        if (message.length > 0) {
            this.validateMessages.push(message);
        }
    }

    private validateSiktrojning(kedjaKopplingar: IVKAtgardKedjaKopplingMasshanteringsResponseDTO[]): string {
        const siktrojnigsTyper = [
            SkogsvardAtgardsTyp.siktrojning,
            SkogsvardAtgardsTyp.nsSiktrojning
        ];
        const antalSiktrojning = kedjaKopplingar.filter(koppling => siktrojnigsTyper.includes(koppling.atgardstyp)).length;

        for(let index=0; index < antalSiktrojning; index++) {
            if (!siktrojnigsTyper.includes(kedjaKopplingar[index].atgardstyp)) {
                return "Siktröjning måste ligga först i åtgärdskedjan";
            }
        }
        return "";
    }

    private validateGrot(kedjaKopplingar: IVKAtgardKedjaKopplingMasshanteringsResponseDTO[]): string {
        const indexGrot = kedjaKopplingar.findIndex(koppling => koppling.atgardsgrupp === VirkeskopAtgardsgrupper.Grot);
        const indexRv = kedjaKopplingar.findIndex(koppling => koppling.atgardsgrupp === VirkeskopAtgardsgrupper.Avverkning);
        if (indexGrot > -1 && indexGrot < indexRv) {
            return "Grot måste ligga efter rundvirke i åtgärdskedjan";
        }
        return "";
    }
}
